<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <el-row class="pagebody">
      <el-row class="filter-bar">
        <el-card shadow="never">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="200px" size="small">
            <el-row >
              <el-col :span="20">
                <el-form-item label="可用区名称：" prop="name" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.name" style="width:175px" />
                </el-form-item>
                <el-form-item label="提供商:" prop="provider" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.provider" style="width:175px" />
                </el-form-item>
                <el-form-item label="GPU型号:" prop="gpu_model" class="search-item" :label-width="labelWidth">
                  <el-input v-model="searchForm.gpu_model" style="width:175px" />
                </el-form-item>
                <el-form-item label="状态:" prop="status" class="search-item" :label-width="labelWidth">
                  <el-select v-model="searchForm.status" placeholder="请选择状态">
                    <el-option label="全部状态" value=""></el-option>
                    <el-option label="有效" value="0"></el-option>
                    <el-option label="无效" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" icon="el-icon-search" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleSearch">
                  查询
                </el-button>
                <el-button type="info" icon="el-icon-refresh-left" size="small" plain style="margin-left:8px;"
                           class="fr"
                           @click="handleReset">
                  重置
                </el-button>
              </el-col>
              <el-col :span="24">
                <div class="action-buttons-row">
                  <el-button type="success" icon="el-icon-plus" size="small" plain
                    @click="handleCreate">
                    新增
                  </el-button>
                  <el-button type="primary" icon="el-icon-upload" size="small" plain
                    @click="handleImport">
                    导入
                  </el-button>
                  <el-button type="primary" icon="el-icon-download" size="small" plain
                    @click="handleExport">
                    导出
                  </el-button>
                  <el-button type="primary" icon="el-icon-document" size="small" plain
                    @click="handleDownloadTemplate">
                    下载模板
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-row>
      <el-row class="main-table">
          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%">
          <el-table-column fixed prop="name" label="可用区名称" width="140px" />
          <el-table-column prop="provider" label="提供商" width="140px" />
          <el-table-column prop="gpu_model" label="GPU型号" width="140px" />
          <el-table-column prop="scale" label="规模" width="140px" />
          <!-- 资源可用期限（时间段） -->
          <el-table-column label="资源可用期限" width="200">
            <template v-slot="scope">
                <div v-if="scope.row.start_time || scope.row.end_time">
                  {{ (scope.row.start_time || '').split(' ')[0] || '–' }}
                  至
                  {{ (scope.row.end_time || '').split(' ')[0] || '–' }}
                </div>
                <span v-else>-</span>
              </template>
          </el-table-column>
          <!-- 租赁规模 -->
            <el-table-column prop="lease_scale" label="租赁规模" width="120">
              <template v-slot="scope">
                <el-tag :type="getTagType(scope.row.lease_scale)">
                  {{ formatLeaseScale(scope.row.lease_scale) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 租赁形式 -->
            <el-table-column prop="lease_type" label="租赁形式" width="100">
              <template v-slot="scope">
                 <el-tag :type="getTagType(scope.row.lease_type)">
                  {{ formatLeaseType(scope.row.lease_type) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column prop="status" label="状态" width="100">
              <template v-slot="scope">
                 <el-tag :type="getTagTypeformat(scope.row.status)">
                  {{ formatStatus(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 是否纳管 -->
            <el-table-column prop="ext_01" label="是否纳管" width="100">
              <template v-slot="scope">
                <el-tag type="info">
                  {{ formatExt01(scope.row.ext_01) }}
                </el-tag>
              </template>
            </el-table-column>
          <el-table-column prop="price" label="价格" width="120" show-overflow-tooltip />
          <el-table-column prop="device_specification" label="设备规格" width="130px" />
          <el-table-column prop="storage" label="存储" width="130px" />
          <el-table-column prop="storage_network" label="存储网络" width="130px" />
          <el-table-column prop="compute_network" label="计算网络" width="140px" />
          <el-table-column prop="internet_spec" label="出口规格" width="140px" />
          <el-table-column prop="created_at" label="创建时间" width="200px">
            <template #default="{ row }">
              {{ formatDateTime(row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" header-align="center" align="center" show-overflow-tooltip width="180" label="操作">
          <template v-slot="scope">
            <!-- 使用 v-if 控制按钮的显示 -->
            <el-button
              type="text" 
              size="mini" 
              @click="editZones(scope.row)">编辑</el-button>
              <el-button
              type="text" 
              size="mini" 
              @click="delZones(scope.row)">删除</el-button>
              <el-button
              type="text" 
              size="mini" 
              @click="devicesList(scope.row)">设备列表</el-button>
          </template>
        </el-table-column>
        </el-table>
      </el-row>
      <el-row type="flex" justify="left" style="margin-top: 10px; margin-bottom: 18px;">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>

    <!-- 引入 CreateZones 组件 -->
    <create-zones ref="createZones" @success="getTableData"></create-zones>
     <!-- 编辑组件 -->
    <edit-zones ref="editZones" @success="getTableData"></edit-zones>

  </d2-container>
</template>

<script>

import topLine from "@/components/save-common/topLine.vue";
import CreateZones from '../available_zones/CreateZones.vue'; //
import EditZones from '../available_zones/EditZones.vue'; // 引入编辑组件
import commonListMixin from "@/pages/mixin/mixin-common-list";
import util from '@/libs/util.js'
import { MessageBox } from 'element-ui';

export default {
  name: "allns",
  // mixins: [
  //   commonListMixin
  // ],
  components: {
    topLine,
    CreateZones,
    EditZones
  },
  created() {
    const provider = this.$route.query.provider;
    if (provider) {
      this.searchForm.provider = provider;
      if (this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10);
      }
      if (this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
      }
    }
    this.getTableData();
  },
  mounted () {
  },
  data() {
    return {
      pageTitle: "可用区",
      labelWidth: '120px',
      tableDataApi: '/api-30216/api/zones',
      searchForm: {
        name: '',
        provider: '',
        gpu_model: '',
        status:'',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
      },
      tableData: []
    }
  },
  methods: {
    formatLeaseScale(value) {
      const map = {
        0: '任意',
        1: '整租',
        2: '散租'
      };
      return map[value] || '-';
    },
    getTagType(value) {
      switch (value) {
        case 0:
          return 'info';     // '任意' → 灰色
        case 1:
          return 'success';  // '整租' → 绿色
        case 2:
          return 'warning';  // '散租' → 黄色
        default:
          return 'info';
      }
    },
    // 格式化租赁形式
    formatLeaseType(value) {
      const map = {
        0: '任意',
        1: '开口',
        2: '闭口'
      };
      return map[value] || '-';
    },

    // 格式化状态
    formatStatus(value) {
      const map = {
        0: '有效',
        1: '无效',
      };
      return map[value] || '-';
    },
    // 格式化是否纳管
    formatExt01(value) {
      const map = {
        0: '纳管',
        1: '非纳管',
      };
      return map[value] || '未知';
    },
    getTagTypeformat(value) {
      switch (value) {
        case 0:
          return 'success';     // '有效' → 绿色
        case 1:
          return 'danger';  // '关闭' → 红色
        case 2:
          return 'info';  // '待定' → 灰色
        default:
          return 'info';
      }
    },

    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const Y = date.getFullYear() + '-';
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },

    loadParams() {
      if(this.$route.query.page) {
        this.pagination.page = parseInt(this.$route.query.page, 10);
      }
      if(this.$route.query.pageSize) {
        this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
      }
    },
    handleReset() {
      this.searchForm = {
        name: '',
        provider: '',
        gpu_model: '',
        status:'',
        page: 1,
        pageSize: 10,
      };
      this.getTableData();
    },
    //查询
    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.updateQueryParams();
      this.getTableData();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.updateQueryParams();
      this.getTableData();
    },
    // 新增方法
    updateQueryParams() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
      });
    },
    getTableData() {
      this.$axios.get(this.tableDataApi, {
        params: {
          name: this.searchForm.name,
          provider: this.searchForm.provider,
          gpu_model: this.searchForm.gpu_model,
          status: this.searchForm.status,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
        }
      }).then(response => {
        console.log(response);
        this.tableData = response.data || [];
        this.pagination.total = response.total || 0;
      });
    },
    // 新增方法
    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        // 加判断，避免 clearValidate 报错
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
      });
    },
    // 新增弹窗
    handleCreate() {
      this.$refs.createZones.openDialog(); 
    },

    // 编辑弹窗
    editZones(row) {
      this.$refs.editZones.openDialog(row); // 将当前行数据传给 editZones
    },

    // 删除
    delZones(row) {
      MessageBox.confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         this.$axios.delete(`/api-30216/api/zones/${row.id}`).then(response => {
          if (response.code === 200) {
            this.$message.success(response.message || '删除成功');
          } else {
            this.$message.error(response.message || '删除失败');
          }
          this.getTableData();
        }).catch(error => {
          console.error(error);
          this.$message.error('删除失败，请检查网络或服务状态');
        });
        
      }).catch(() => {
        // 用户点击“取消”或关闭弹窗时触发
        this.$message.info('已取消删除');
      });
    },

    // 跳转设备页
    devicesList(row) {
      this.$router.push({
        path: '/api/devices',
        query: {
          name: row.name,               // ✅ 传递了可用区名称
          provider: row.provider,       // ✅ 传递了提供商
          page: this.pagination.page,       // 当前页码
          pageSize: this.pagination.pageSize, // 页面大小
        }
      })
    },

    /**
   * 导出数据
   */
    async handleExport() {
      const { name, provider, gpu_model, status } = this.searchForm;
      const params = {};
      if (name) params.name = name;
      if (provider) params.provider = provider;
      if (gpu_model) params.gpu_model = gpu_model;
      if (status !== '') params.status = Number(status);

      const queryString = new URLSearchParams(params).toString();
      const url = `/api-30216/api/zones/export?${queryString}`;

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${util.cookies.get('token')}`,
          }
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`导出失败：${response.status} ${errorText}`);
        }

        // 获取 headers
        const contentDisposition = response.headers.get('Content-Disposition');
        const contentType = response.headers.get('Content-Type');
        const blob = await response.blob();

        // 👇 解析文件名（兼容中文）
        let filename = 'regions_export.xlsx';

        if (contentDisposition) {
          // 匹配 filename*=UTF-8'' 开头的编码格式（RFC 5987）
          let utf8FilenameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
          if (utf8FilenameMatch) {
            try {
              filename = decodeURIComponent(utf8FilenameMatch[1]);
            } catch (e) {
              console.error('解码 filename* 失败', e);
            }
          } else {
            // 否则匹配普通的 filename="..."
            const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1];
              // 尝试修复乱码：假设原意是 UTF-8，但被错误解析
              try {
                // 检查是否是乱码（如 "åä¸º.xlsx" 这种）
                const encoded = new Uint8Array(await blob.slice(0, 1).arrayBuffer()).length > 0;
                // 简单判断：如果文件名看起来像乱码，尝试用 UTF-8 重新解码
                const blobText = await new Response(blob).text();
                // 触发一次字符集猜测（较复杂，这里用简单方法）
                if (filename.includes('%E') || /[\u0080-\uFFFF]/.test(filename)) {
                  // 可能是被错误编码的 UTF-8 字节流
                  const ab = await blob.slice(0, 10).arrayBuffer(); // 取一小段
                  const decoder = new TextDecoder('utf-8');
                  const sample = decoder.decode(ab);
                  // 如果 sample 包含乱码特征，可尝试修复
                }
              } catch (e) {}
            }
          }
        }

        // 🔽 关键：使用 Blob URL 下载
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename; // 这里传入正确解码的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        this.$message.success('导出成功');
      } catch (error) {
        console.error('导出失败', error);
        this.$message.error('导出失败，请稍后重试');
      }
    },
      

  /**
   * 导入数据
   */
  async handleImport() {
    // 使用 input[type=file] 动态创建
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls,.csv'; // 可根据后端支持调整
    input.onchange = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await fetch('/api-30216/api/zones/import', {
          method: 'POST',
          body: formData,
          headers: {
            // 注意：不要手动设置 Content-Type，让浏览器自动设置 boundary
            'Authorization': `Bearer ${util.cookies.get('token')}` // 根据你的鉴权方式调整
          }
        });

        const result = await response.json();

        if (response.ok) {
          this.$message.success(result.message || '导入成功');
          this.getTableData(); // 刷新列表
        } else {
          this.$message.error(result.error || '导入失败');
        }
      } catch (error) {
        console.error('导入请求异常', error);
        this.$message.error('网络错误，导入失败');
      }
    };
    input.click(); // 触发文件选择
  },

   /**
   * 下载导入模板
   */
    async handleDownloadTemplate() {
      const url = '/api-30216/api/zones/template';
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${util.cookies.get('token')}`
          }
        });

        if (!response.ok) throw new Error('下载失败');

        const blob = await response.blob();

        // 👇 解析后端返回的文件名
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'providers_import_template.xlsx'; // 默认名

        if (contentDisposition) {
          // 优先匹配 UTF-8 编码格式：filename*=UTF-8''...
          const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
          if (utf8Match) {
            try {
              filename = decodeURIComponent(utf8Match[1]);
            } catch (e) {
              console.warn('decode filename* failed', e);
            }
          } else {
            // 匹配普通 filename="..."
            const match = contentDisposition.match(/filename="?([^"]+)"?/i);
            if (match && match[1]) {
              filename = match[1];
            }
          }
        }

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        this.$message.success('模板下载成功');
      } catch (error) {
        console.error('下载模板失败', error);
        this.$message.error('下载模板失败，请检查网络或联系管理员');
      }
    },

    
    
  }

}
</script>

<style scoped lang="scss"> 
.pagebody {
  margin-top: 20px;
  margin-left: 20px;
}
.filter-bar {
  margin-bottom: 10px;
}
.main-table {
  margin-top: 10px;
}

.search-button-line {
  display: flex;
  justify-content: flex-end;
}
.batch-button {
  min-width: 95px;
}

.action-buttons-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.action-buttons-row .el-button {
  margin-left: 0 !important;
}
</style>